export const API_S3 = 'https://samuel-cunha-api.s3.sa-east-1.amazonaws.com';